"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _Text = _interopRequireDefault(require("react-native-web/dist/cjs/exports/Text"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _ButtonBase = _interopRequireDefault(require("../Button/ButtonBase"));
var _Icon = require("../Icon");
var _ThemeProvider = require("../ThemeProvider");
var _ViewportProvider = require("../ViewportProvider");
var _utils = require("../utils");
var _dictionary = _interopRequireDefault(require("./dictionary"));
var _useCopy = _interopRequireDefault(require("../utils/useCopy"));
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
// We need to drop the icon here since it gets rendered via children and not
// `ButtonBase` in order to tap into the state of the button; `displayLabel` flag
// is also not needed
const selectButtonTokens = _ref => {
  let {
    icon: _,
    displayLabel: __,
    ...rest
  } = _ref;
  return (0, _utils.selectTokens)('Button', rest);
};
const selectIconTokens = (_ref2, direction) => {
  let {
    color,
    iconSize,
    iconDisplace
  } = _ref2;
  return {
    color,
    size: iconSize,
    translateX: iconDisplace * (direction === 'previous' ? -1 : 1)
  };
};
const directionToSide = {
  previous: 'left',
  next: 'right'
};
const SideButton = /*#__PURE__*/_react.default.forwardRef((_ref3, ref) => {
  let {
    direction = 'previous',
    onPress,
    href,
    copy,
    variant,
    tokens,
    ...props
  } = _ref3;
  const viewport = (0, _ViewportProvider.useViewport)();
  const buttonVariant = {
    direction,
    viewport,
    ...variant
  };
  const getTokens = (0, _ThemeProvider.useThemeTokensCallback)('PaginationSideButton', tokens, buttonVariant);
  const getCopy = (0, _useCopy.default)({
    dictionary: _dictionary.default,
    copy
  });
  const {
    icon,
    displayLabel
  } = getTokens(tokens, buttonVariant);
  const getButtonTokens = buttonState => selectButtonTokens(getTokens(buttonState));
  const getIconTokens = buttonState => selectIconTokens(getTokens(buttonState), direction);
  const label = direction === 'previous' ? getCopy('previousText') : getCopy('nextText');
  const accessibilityLabel = direction === 'previous' ? getCopy('previousLabel') : getCopy('nextLabel');
  const accessibilityRole = href !== undefined ? 'link' : 'button';
  const {
    hrefAttrs,
    rest
  } = _utils.hrefAttrsProp.bundle(props);
  const buttonProps = {
    accessibilityRole,
    accessibilityLabel,
    onPress,
    href,
    hrefAttrs,
    ...rest
  };
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_ButtonBase.default, {
    ref: ref,
    ...buttonProps,
    tokens: getButtonTokens,
    children: _ref4 => {
      let {
        textStyles,
        ...buttonState
      } = _ref4;
      const iconProps = {
        tokens: getIconTokens(buttonState)
      };
      return /*#__PURE__*/(0, _jsxRuntime.jsx)(_Icon.IconText, {
        icon: icon,
        space: 1,
        iconPosition: directionToSide[direction],
        iconProps: iconProps,
        children: displayLabel && /*#__PURE__*/(0, _jsxRuntime.jsx)(_Text.default, {
          style: textStyles,
          children: label
        })
      });
    }
  });
});
SideButton.displayName = 'SideButton';
SideButton.propTypes = {
  direction: _propTypes.default.oneOf(['previous', 'next']),
  copy: _utils.copyPropTypes,
  ..._utils.linkProps.types
};
var _default = exports.default = (0, _utils.withLinkRouter)(SideButton);